<template>
  <div
    class="modal fade show"
    style="display: block"
    @click.self="$emit('close')"
  >
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content bg-dark">
        <div class="modal-header border-secondary">
          <h5 class="modal-title text-white">
            Media Gallery ({{ currentIndex + 1 }} of {{ media.length }})
          </h5>
          <button
            type="button"
            class="btn-close btn-close-white"
            @click="$emit('close')"
          ></button>
        </div>

        <div class="modal-body p-0 position-relative">
          <!-- Media Display -->
          <div class="media-display">
            <img
              v-if="isImage(currentMedia)"
              :src="currentMedia"
              :alt="`Media ${currentIndex + 1}`"
              class="current-media"
            />
            <video
              v-else-if="isVideo(currentMedia)"
              :src="currentMedia"
              controls
              class="current-media"
            >
              Your browser does not support the video tag.
            </video>
          </div>

          <!-- Navigation Arrows -->
          <button
            v-if="media.length > 1"
            class="nav-arrow nav-arrow-prev"
            @click="goToPrevious"
            :disabled="currentIndex === 0"
          >
            <i class="fas fa-chevron-left"></i>
          </button>

          <button
            v-if="media.length > 1"
            class="nav-arrow nav-arrow-next"
            @click="goToNext"
            :disabled="currentIndex === media.length - 1"
          >
            <i class="fas fa-chevron-right"></i>
          </button>
        </div>

        <!-- Thumbnails -->
        <div v-if="media.length > 1" class="modal-footer border-secondary">
          <div class="thumbnails-container">
            <div
              v-for="(mediaUrl, index) in media"
              :key="index"
              class="thumbnail"
              :class="{ active: index === currentIndex }"
              @click="currentIndex = index"
            >
              <img
                v-if="isImage(mediaUrl)"
                :src="mediaUrl"
                :alt="`Thumbnail ${index + 1}`"
                class="thumbnail-image"
              />
              <div v-else-if="isVideo(mediaUrl)" class="thumbnail-video">
                <i class="fas fa-play"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show"></div>
</template>

<script>
export default {
  name: "MediaViewer",
  props: {
    media: {
      type: Array,
      required: true,
    },
    initialIndex: {
      type: Number,
      default: 0,
    },
  },
  emits: ["close"],
  data() {
    return {
      currentIndex: this.initialIndex,
    };
  },
  computed: {
    currentMedia() {
      return this.media[this.currentIndex];
    },
  },
  methods: {
    goToPrevious() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
      }
    },

    goToNext() {
      if (this.currentIndex < this.media.length - 1) {
        this.currentIndex++;
      }
    },

    isImage(url) {
      return /\.(jpg|jpeg|png|gif|webp)$/i.test(url);
    },

    isVideo(url) {
      return /\.(mp4|avi|mov|wmv|flv|webm)$/i.test(url);
    },

    handleKeyPress(event) {
      switch (event.key) {
        case "Escape":
          this.$emit("close");
          break;
        case "ArrowLeft":
          this.goToPrevious();
          break;
        case "ArrowRight":
          this.goToNext();
          break;
      }
    },
  },
  mounted() {
    // Add keyboard navigation
    document.addEventListener("keydown", this.handleKeyPress);
  },

  beforeUnmount() {
    document.removeEventListener("keydown", this.handleKeyPress);
  },
};
</script>

<style scoped>
.modal {
  z-index: 1055;
}

.modal-backdrop {
  z-index: 1050;
}

.media-display {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  background: #000;
}

.current-media {
  max-width: 100%;
  max-height: 60vh;
  object-fit: contain;
}

.nav-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  transition: all 0.3s ease;
  z-index: 10;
}

.nav-arrow:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.3);
  transform: translateY(-50%) scale(1.1);
}

.nav-arrow:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.nav-arrow-prev {
  left: 20px;
}

.nav-arrow-next {
  right: 20px;
}

.thumbnails-container {
  display: flex;
  gap: 0.5rem;
  overflow-x: auto;
  padding: 0.5rem 0;
  max-width: 100%;
}

.thumbnail {
  flex-shrink: 0;
  width: 60px;
  height: 60px;
  border-radius: 4px;
  overflow: hidden;
  cursor: pointer;
  border: 2px solid transparent;
  transition: all 0.3s ease;
}

.thumbnail.active {
  border-color: var(--primary-color);
}

.thumbnail:hover {
  border-color: rgba(255, 255, 255, 0.5);
}

.thumbnail-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.thumbnail-video {
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

@media (max-width: 768px) {
  .nav-arrow {
    width: 40px;
    height: 40px;
    font-size: 1rem;
  }

  .nav-arrow-prev {
    left: 10px;
  }

  .nav-arrow-next {
    right: 10px;
  }

  .thumbnail {
    width: 50px;
    height: 50px;
  }
}
</style>
